import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const STATS = [
  { n: "20+", l: "Projets livrés" },
  { n: "100%", l: "Satisfaction clients" },
  { n: "24/7", l: "Support disponible" },
  { n: "2", l: "Entités expertes" },
];

const ENTITIES = [
  {
    id: "cleaners", emoji: "🧹", color: "#1a6b3c", bg: "linear-gradient(135deg,#1a6b3c,#2d9b5c)",
    label: "PurePro Cleaners", tag: "Nettoyage Professionnel",
    desc: "Spécialiste du nettoyage, entretien de piscines, climatisation et traitement antiparasitaire. Des équipes formées, des produits écologiques certifiés.",
    services: ["Nettoyage & Entretien de locaux", "Piscines & Climatisation", "Dératisation / Désinsectisation", "Nettoyage industriel & chantier"],
    href: "https://www.pureprocleaners.ci",
  },
  {
    id: "techno", emoji: "💻", color: "#f97316", bg: "linear-gradient(135deg,#0a2540,#1e3a5f)",
    label: "PurePro Technologie", tag: "Transformation Digitale",
    desc: "Expert en développement d'applications, sites web, sécurité électronique, équipements IT et formation IA. Votre partenaire numérique.",
    services: ["Développement Mobile & Web", "Sécurité électronique", "Équipement & Maintenance IT", "Formation IA & Data Science"],
    href: "https://www.purepro-technologie.ci",
  },
];

const REASONS = [
  { icon: "🏆", title: "Multi-expertise", desc: "Cleaners + Technologie = partenaire unique pour tous vos besoins" },
  { icon: "📋", title: "Devis transparent", desc: "Pas de frais cachés, devis détaillé et contractualisé avant toute intervention" },
  { icon: "⭐", title: "100% satisfaction", desc: "Un engagement qualité sans compromis dans chaque prestation" },
  { icon: "🔧", title: "Support 7j/7", desc: "Réactivité garantie et suivi personnalisé pour chaque client" },
  { icon: "🌱", title: "Produits écologiques", desc: "Respect de l'environnement avec des produits certifiés" },
  { icon: "🔗", title: "Réseau de partenaires", desc: "Écosystème d'experts pour les projets les plus complexes" },
];

const PROCESS = [
  { n: "01", title: "Prise de contact", desc: "Analyse de vos besoins et proposition d'une solution adaptée" },
  { n: "02", title: "Proposition", desc: "Devis détaillé, transparent et sans surprise sous 24h" },
  { n: "03", title: "Planification", desc: "Signature du contrat, définition du planning, équipe dédiée" },
  { n: "04", title: "Exécution", desc: "Réalisation avec points d'avancement réguliers" },
  { n: "05", title: "Contrôle qualité", desc: "Vérification systématique avant livraison" },
  { n: "06", title: "Livraison & Suivi", desc: "Support post-livraison et bilan de satisfaction" },
];

export default function Home() {
  const heroRef = useRef();

  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;
    const onMove = (e) => {
      const { clientX, clientY } = e;
      const { width, height } = el.getBoundingClientRect();
      const x = (clientX / width - 0.5) * 12;
      const y = (clientY / height - 0.5) * 8;
      el.style.setProperty("--rx", `${y}deg`);
      el.style.setProperty("--ry", `${x}deg`);
    };
    el.addEventListener("mousemove", onMove);
    return () => el.removeEventListener("mousemove", onMove);
  }, []);

  return (
    <div>
      {/* Styles responsives intégrés */}
   

      {/* ─── HERO ─── */}
      <section ref={heroRef} style={s.hero}>
        <div style={s.heroBg} />
        <div style={s.heroPattern} />
        <div className="container" style={{ position: "relative", zIndex: 2, paddingTop: "120px", paddingBottom: "100px" }}>
          <div style={s.heroContent}>
            <h1 style={s.heroTitle}>
              Votre partenaire <span style={{ color: "#c9a227" }}>multi-expertise</span><br />
              en Côte d'Ivoire
            </h1>
            <p style={s.heroSub}>
              PurePro Group réunit deux entités complémentaires — nettoyage professionnel et transformation digitale —
              pour accompagner entreprises et institutions avec rigueur, innovation et excellence.
            </p>
            <div className="hero-ctas" style={s.heroCtas}>
              <Link to="/devis" className="btn btn-primary" style={{ padding: "15px 32px", fontSize: "15px" }}>
                Devis gratuit →
              </Link>
              <Link to="/services" className="btn btn-outline" style={{ padding: "15px 32px", fontSize: "15px" }}>
                Découvrir nos services
              </Link>
            </div>

            {/* Stats bar */}
            <div className="stats-bar" style={s.statsBar}>
              {STATS.map((st) => (
                <div key={st.n} style={s.statItem}>
                  <div style={s.statNum}>{st.n}</div>
                  <div style={s.statLabel}>{st.l}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div style={s.scrollIndicator}>
          <div style={s.scrollDot} />
        </div>
      </section>

      {/* ─── ENTITÉS ─── */}
      <section className="section" style={{ background: "#f8f9fc" }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: "50px" }}>
            <div className="section-tag">Nos entités</div>
            <h2 className="section-title">Deux expertises, <span>un seul groupe</span></h2>
            <div className="gold-line center" />
            <p className="section-sub" style={{ margin: "0 auto" }}>
              PurePro Group s'appuie sur deux filiales complémentaires pour couvrir l'ensemble de vos besoins opérationnels et digitaux.
            </p>
          </div>

          <div className="entities-grid">
            {ENTITIES.map((en) => (
              <div key={en.id} style={{ ...s.entityCard }}>
                <div style={{ ...s.entityHeader, background: en.bg }}>
                  <div style={s.entityEmoji}>{en.emoji}</div>
                  <div>
                    <div style={s.entityTag}>{en.tag}</div>
                    <h3 style={s.entityName}>{en.label}</h3>
                  </div>
                </div>
                <div style={s.entityBody}>
                  <p style={s.entityDesc}>{en.desc}</p>
                  <div style={s.entityServices}>
                    {en.services.map((sv) => (
                      <div key={sv} style={{ ...s.entityService, color: en.color }}>
                        <span style={{ color: en.color, fontWeight: 700 }}>✓</span> {sv}
                      </div>
                    ))}
                  </div>
                  <div style={{ marginTop: "20px", display: "flex", gap: "10px", flexWrap: "wrap" }}>
                    <a href={en.href} target="_blank" rel="noreferrer"
                      style={{ ...s.entityBtn, background: en.color, color: "#fff" }}>
                      Visiter le site →
                    </a>
                    <Link to="/devis" style={{ ...s.entityBtn, background: "transparent", color: en.color, border: `1.5px solid ${en.color}` }}>
                      Devis
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── CHIFFRES CLÉS ─── */}
      <section style={s.statsSection}>
        <div className="container">
          <div className="stats-grid">
            {[
              { n: "20+", l: "Projets livrés", icon: "🚀" },
              { n: "100%", l: "Clients satisfaits", icon: "⭐" },
              { n: "2022", l: "Fondé à Abidjan", icon: "📅" },
              { n: "24/7", l: "Disponibilité urgences", icon: "🔴" },
            ].map((st) => (
              <div key={st.n} style={s.bigStat}>
                <div style={s.bigStatIcon}>{st.icon}</div>
                <div style={s.bigStatNum}>{st.n}</div>
                <div style={s.bigStatLabel}>{st.l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── POURQUOI NOUS ─── */}
      <section className="section">
        <div className="container">
          <div className="reasons-grid">
            <div>
              <div className="section-tag">Pourquoi nous choisir ?</div>
              <h2 className="section-title">L'excellence au service<br /><span>de votre réussite</span></h2>
              <div className="gold-line" />
              <p style={{ color: "#4a5a6a", lineHeight: "1.8", marginBottom: "28px" }}>
                Depuis 2022, PurePro Group s'est imposé comme un partenaire de confiance pour les institutions,
                entreprises et particuliers grâce à une approche rigoureuse et personnalisée.
              </p>
              <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
                {REASONS.slice(0, 4).map((r) => (
                  <div key={r.title} style={s.reasonItem}>
                    <div style={s.reasonIcon}>{r.icon}</div>
                    <div>
                      <div style={s.reasonTitle}>{r.title}</div>
                      <div style={s.reasonDesc}>{r.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
              <Link to="/a-propos" className="btn btn-outline-navy" style={{ marginTop: "28px", display: "inline-block" }}>
                En savoir plus
              </Link>
            </div>
            <div className="reasons-cards">
              {REASONS.slice(4).concat(REASONS.slice(0, 2)).map((r, i) => (
                <div key={i} style={s.reasonCard}>
                  <div style={s.reasonCardIcon}>{r.icon}</div>
                  <div style={s.reasonCardTitle}>{r.title}</div>
                  <div style={s.reasonCardDesc}>{r.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ─── PROCESSUS ─── */}
      <section className="section" style={{ background: "#f8f9fc" }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: "50px" }}>
            <div className="section-tag">Notre méthode</div>
            <h2 className="section-title">Notre processus <span>en 6 étapes</span></h2>
            <div className="gold-line center" />
          </div>
          <div className="process-grid">
            {PROCESS.map((p, i) => (
              <div key={p.n} style={{ ...s.processCard, animationDelay: `${i * 0.1}s` }}>
                <div style={s.processNum}>{p.n}</div>
                <h3 style={s.processTitle}>{p.title}</h3>
                <p style={s.processDesc}>{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── CTA FINALE ─── */}
      <section style={s.ctaSection}>
        <div className="container" style={{ textAlign: "center", position: "relative", zIndex: 2 }}>
          <div style={s.ctaTag}>Prêt à démarrer ?</div>
          <h2 style={s.ctaTitle}>Collaborons ensemble pour<br /><span style={{ color: "#c9a227" }}>votre réussite</span></h2>
          <p style={s.ctaSub}>Contactez-nous dès aujourd'hui pour un devis gratuit, sans engagement.</p>
          <div className="cta-buttons">
            <Link to="/devis" className="btn btn-primary" style={{ padding: "16px 40px", fontSize: "16px" }}>
              Demander un devis gratuit →
            </Link>
            <Link to="/contact" className="btn btn-outline" style={{ padding: "16px 40px", fontSize: "16px" }}>
              Nous contacter
            </Link>
          </div>
          <div className="contact-info">
            {["📞 +225 05 75 49 64 57 / 07 77 88 00 82","✉️ contact@purepro-group.ci","📍 Abidjan, Côte d'Ivoire"].map(t=>(
              <span key={t} style={{ color: "rgba(255,255,255,.7)", fontSize: "14px" }}>{t}</span>
            ))}
          </div>
        </div>
        <div style={s.ctaBg} />
      </section>

         <style>{`
        /* Base container */
        .container {
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 24px;
        }
        /* Sections */
        .section {
          padding: 80px 0;
        }
        .section-tag {
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: #c9a227;
          margin-bottom: 12px;
        }
        .section-title {
          font-size: 36px;
          font-weight: 800;
          color: #0a2540;
          margin-bottom: 16px;
          font-family: 'Playfair Display', serif;
        }
        .section-title span {
          color: #c9a227;
        }
        .gold-line {
          width: 60px;
          height: 3px;
          background: #c9a227;
          margin: 16px 0 20px;
        }
        .gold-line.center {
          margin-left: auto;
          margin-right: auto;
        }
        .section-sub {
          font-size: 16px;
          color: #4a5a6a;
          max-width: 700px;
          line-height: 1.7;
        }
        .btn-primary, .btn-outline, .btn-outline-navy {
          display: inline-block;
          border-radius: 40px;
          font-weight: 700;
          text-decoration: none;
          transition: all 0.2s;
          cursor: pointer;
          text-align: center;
        }
        .btn-primary {
          background: #c9a227;
          color: #0a2540;
          border: none;
        }
        .btn-primary:hover {
          background: #b38c1a;
          transform: translateY(-2px);
        }
        .btn-outline {
          background: transparent;
          border: 1.5px solid rgba(255,255,255,0.4);
          color: white;
        }
        .btn-outline:hover {
          border-color: #c9a227;
          background: rgba(201,162,39,0.1);
        }
        .btn-outline-navy {
          background: transparent;
          border: 1.5px solid #0a2540;
          color: #0a2540;
        }
        .btn-outline-navy:hover {
          background: #0a2540;
          color: white;
        }
        .text-center {
          text-align: center;
        }

        /* Grilles responsives */
        .entities-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(480px, 1fr));
          gap: 28px;
        }
        .stats-grid {
          display: flex;
          justify-content: space-around;
          flex-wrap: wrap;
          gap: 32px;
        }
        .reasons-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 64px;
          align-items: center;
        }
        .reasons-cards {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        }
        .process-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
        }
        .cta-buttons {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
          margin-top: 32px;
        }
        .contact-info {
          margin-top: 28px;
          display: flex;
          gap: 24px;
          justify-content: center;
          flex-wrap: wrap;
        }

        /* Media queries */
        @media (max-width: 992px) {
          .section {
            padding: 60px 0;
          }
          .section-title {
            font-size: 32px;
          }
          .reasons-grid {
            grid-template-columns: 1fr;
            gap: 40px;
          }
          .process-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        @media (max-width: 768px) {
          .container {
            padding: 0 20px;
          }
          .entities-grid {
            grid-template-columns: 1fr;
            gap: 24px;
          }
          .stats-grid {
            gap: 28px;
          }
          .big-stat-num {
            font-size: 34px;
          }
          .reasons-cards {
            grid-template-columns: 1fr;
          }
          .process-grid {
            grid-template-columns: 1fr;
            gap: 16px;
          }
          .hero-ctas {
            flex-direction: column;
            align-items: stretch;
          }
          .hero-ctas a {
            text-align: center;
          }
          .stats-bar {
            flex-direction: column;
            gap: 20px;
          }
          .stat-item {
            border-right: none;
            border-bottom: 1px solid rgba(255,255,255,0.1);
            padding: 12px 0;
          }
          .stat-item:last-child {
            border-bottom: none;
          }
        }
        @media (max-width: 480px) {
          .section-title {
            font-size: 28px;
          }
          .hero-title {
            font-size: 32px !important;
          }
          .hero-sub {
            font-size: 15px !important;
          }
          .entity-header {
            flex-direction: column;
            text-align: center;
            padding: 24px !important;
          }
          .entity-body {
            padding: 20px !important;
          }
          .process-card {
            padding: 20px;
          }
          .cta-title {
            font-size: 28px !important;
          }
        }
        /* Animation scroll indicator */
        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(0); }
          50% { opacity: 1; transform: translateY(8px); }
          100% { opacity: 0; transform: translateY(16px); }
        }
      `}</style>
    </div>
  );
}

const s = {
  hero: { minHeight: "100vh", position: "relative", display: "flex", alignItems: "center", overflow: "hidden" },
  heroBg: { position: "absolute", inset: 0, background: "linear-gradient(135deg, #061626 0%, #0a2540 40%, #1e3a5f 100%)", zIndex: 0 },
  heroPattern: { position: "absolute", inset: 0, backgroundImage: "radial-gradient(circle at 20% 50%, rgba(201,162,39,.08) 0%, transparent 60%), radial-gradient(circle at 80% 20%, rgba(30,58,95,.6) 0%, transparent 50%)", zIndex: 1 },
  heroContent: { maxWidth: "720px" },
  heroTitle: { fontSize: "clamp(36px,5.5vw,64px)", fontWeight: 900, color: "#fff", lineHeight: 1.15, marginBottom: "20px", fontFamily: "'Playfair Display', serif" },
  heroSub: { fontSize: "17px", color: "rgba(255,255,255,.72)", lineHeight: "1.8", marginBottom: "32px", maxWidth: "600px" },
  heroCtas: { display: "flex", gap: "14px", flexWrap: "wrap", marginBottom: "48px" },
  statsBar: { display: "flex", gap: "0", borderTop: "1px solid rgba(255,255,255,.12)", paddingTop: "32px" },
  statItem: { flex: 1, textAlign: "center", borderRight: "1px solid rgba(255,255,255,.1)", padding: "0 20px" },
  statNum: { fontSize: "32px", fontWeight: 900, color: "#c9a227", marginBottom: "4px" },
  statLabel: { fontSize: "12px", color: "rgba(255,255,255,.5)", fontWeight: 600, letterSpacing: ".5px" },
  scrollIndicator: { position: "absolute", bottom: "28px", left: "50%", transform: "translateX(-50%)", width: "24px", height: "38px", borderRadius: "12px", border: "2px solid rgba(255,255,255,.2)", display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "6px" },
  scrollDot: { width: "4px", height: "10px", borderRadius: "2px", background: "#c9a227", animation: "fadeUp 1.5s ease infinite" },
  entityCard: { background: "#fff", borderRadius: "20px", overflow: "hidden", boxShadow: "0 4px 30px rgba(10,37,64,.1)", transition: "transform .25s, box-shadow .25s" },
  entityHeader: { padding: "32px", display: "flex", alignItems: "center", gap: "18px" },
  entityEmoji: { fontSize: "40px", background: "rgba(255,255,255,.15)", width: "64px", height: "64px", borderRadius: "16px", display: "flex", alignItems: "center", justifyContent: "center" },
  entityTag: { fontSize: "11px", fontWeight: 700, color: "rgba(255,255,255,.7)", letterSpacing: "1.5px", textTransform: "uppercase", marginBottom: "4px" },
  entityName: { fontSize: "22px", fontWeight: 800, color: "#fff" },
  entityBody: { padding: "28px 32px" },
  entityDesc: { color: "#4a5a6a", lineHeight: "1.7", marginBottom: "20px", fontSize: "14px" },
  entityServices: { display: "flex", flexDirection: "column", gap: "8px" },
  entityService: { fontSize: "13px", fontWeight: 600, display: "flex", gap: "8px", alignItems: "center" },
  entityBtn: { padding: "10px 20px", borderRadius: "8px", fontSize: "13px", fontWeight: 700, cursor: "pointer", textDecoration: "none", display: "inline-block", transition: "all .2s" },
  statsSection: { background: "linear-gradient(135deg,#0a2540,#1e3a5f)", padding: "60px 0" },
  bigStat: { textAlign: "center" },
  bigStatIcon: { fontSize: "28px", marginBottom: "8px" },
  bigStatNum: { fontSize: "42px", fontWeight: 900, color: "#c9a227", lineHeight: 1 },
  bigStatLabel: { fontSize: "13px", color: "rgba(255,255,255,.6)", marginTop: "6px", fontWeight: 600 },
  reasonItem: { display: "flex", gap: "14px", alignItems: "flex-start", padding: "14px", borderRadius: "10px", background: "#f8f9fc", border: "1px solid #eef1f8" },
  reasonIcon: { fontSize: "22px", flexShrink: 0 },
  reasonTitle: { fontWeight: 700, color: "#0a2540", marginBottom: "3px", fontSize: "14px" },
  reasonDesc: { fontSize: "13px", color: "#4a5a6a" },
  reasonCard: { padding: "20px", borderRadius: "14px", background: "#f8f9fc", border: "1px solid #eef1f8", transition: "all .2s" },
  reasonCardIcon: { fontSize: "26px", marginBottom: "10px" },
  reasonCardTitle: { fontWeight: 700, color: "#0a2540", marginBottom: "6px", fontSize: "14px" },
  reasonCardDesc: { fontSize: "12px", color: "#4a5a6a", lineHeight: "1.6" },
  processCard: { background: "#fff", borderRadius: "16px", padding: "28px", border: "1px solid #eef1f8", boxShadow: "0 2px 16px rgba(10,37,64,.06)", position: "relative", overflow: "hidden" },
  processNum: { fontSize: "48px", fontWeight: 900, color: "rgba(201,162,39,.15)", lineHeight: 1, marginBottom: "12px", fontFamily: "'Playfair Display',serif" },
  processTitle: { fontWeight: 700, color: "#0a2540", fontSize: "16px", marginBottom: "8px" },
  processDesc: { fontSize: "13px", color: "#4a5a6a", lineHeight: "1.6" },
  ctaSection: { position: "relative", padding: "100px 0", overflow: "hidden" },
  ctaBg: { position: "absolute", inset: 0, background: "linear-gradient(135deg,#0a2540 0%,#1e3a5f 100%)", zIndex: 0 },
  ctaTag: { fontSize: "12px", fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "#c9a227", marginBottom: "16px" },
  ctaTitle: { fontSize: "clamp(28px,4vw,48px)", fontWeight: 900, color: "#fff", marginBottom: "16px", fontFamily: "'Playfair Display',serif", lineHeight: 1.2 },
  ctaSub: { fontSize: "16px", color: "rgba(255,255,255,.65)", maxWidth: "500px", margin: "0 auto", lineHeight: "1.7" },
};